// extracted by css-extract-rspack-plugin
export default {"flowContainer":"flow-module__flowContainer___kgm8k","Large":"flow-module__Large___su7dY","Small":"flow-module__Small___Kui1V"};